export const sequence = {
    sequence_empty_list: 'سيكون هناك استبيان جديد متاح قريبًا. سنقوم بإبلاغك عبر الرسائل النصية أو البريد الإلكتروني!',
};
